import { Icon } from "@iconify/react";

/**
 * 5-star display with half-star support (e.g. 4.7 → four full + one half).
 * @param {number} rating — typically 0–5 (decimals OK)
 * @param {"default"|"hero"} tone — hero: empty stars visible on dark gradient
 * @param {"sm"|"md"} size
 */
const Rater = ({ rating, max = 5, tone = "default", size = "sm", className = "" }) => {
  const r =
    rating == null || Number.isNaN(Number(rating)) ? 0 : Math.min(max, Math.max(0, Number(rating)));
  const full = Math.floor(r);
  const half = r - full >= 0.5 ? 1 : 0;
  const empty = Math.max(0, max - full - half);
  const starCls = size === "md" ? "w-5 h-5" : "w-4 h-4";
  const emptyTone =
    tone === "hero" ? "text-white/40" : "text-slate-300";

  return (
    <div className={`flex flex-row items-center gap-0.5 shrink-0 ${className}`} aria-hidden>
      {[...Array(full)].map((_, i) => (
        <Icon key={`f${i}`} icon="mdi:star" className={`${starCls} text-amber-400`} />
      ))}
      {half ? <Icon icon="mdi:star-half-full" className={`${starCls} text-amber-400`} /> : null}
      {[...Array(empty)].map((_, i) => (
        <Icon key={`e${i}`} icon="mdi:star-outline" className={`${starCls} ${emptyTone}`} />
      ))}
    </div>
  );
};

export default Rater;
